import { fromClassArray } from "fw-model";
import { ApplicationProperty } from "./application-settings";

export class ApplicantSettings {
  @fromClassArray(ApplicationProperty) ApplicantProperties: ApplicationProperty[];
}
